// Pane layout for full-height screens (Workspace, Assistant, Exports): a CSS grid of independently scrolling panes with hairline dividers.
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

interface SplitPaneProps {
  children: ReactNode;
  className?: string;
}

export function SplitPane({ children, className }: SplitPaneProps) {
  return <div className={cn("grid h-full min-h-0 [&>*]:min-h-0 [&>*]:min-w-0", className)}>{children}</div>;
}

interface PaneProps {
  children: ReactNode;
  as?: "section" | "aside" | "nav" | "div";
  label?: string;
  border?: "left" | "right" | "none";
  surface?: "card" | "viewer" | "page";
  scroll?: boolean;
  className?: string;
}

export function Pane({
  children,
  as: Element = "section",
  label,
  border = "none",
  surface = "card",
  scroll = true,
  className,
}: PaneProps) {
  return (
    <Element
      aria-label={label}
      className={cn(
        "flex min-h-0 flex-col",
        scroll && "pane-scroll",
        surface === "card" && "bg-card",
        surface === "viewer" && "bg-viewer",
        surface === "page" && "bg-background",
        border === "left" && "border-l",
        border === "right" && "border-r",
        className,
      )}
    >
      {children}
    </Element>
  );
}
